import { uiSurface } from "shared/ui/uiSurface"
import { Lock } from "@mui/icons-material"
import { Box, Paper, Stack, Typography } from "@mui/material"
import { FC } from "react"
import { useTranslation } from "react-i18next"

export const LockersTab: FC = () => {
  const { t } = useTranslation()

  return (
    <Box
      {...uiSurface("UI-DLV2-180")}
      data-testid="lockers-tab"
      sx={{ display: "flex", justifyContent: "center", py: 8, px: 3 }}
    >
      <Paper
        variant="outlined"
        sx={{
          p: 6,
          borderRadius: 3,
          maxWidth: 480,
          width: "100%",
          textAlign: "center",
          bgcolor: "background.paper",
        }}
      >
        <Stack alignItems="center" spacing={3}>
          <Box
            sx={{
              width: 88,
              height: 88,
              borderRadius: "50%",
              bgcolor: "primary.50",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Lock sx={{ fontSize: 44, color: "primary.main" }} />
          </Box>
          <Box>
            <Typography
              variant="h5"
              fontWeight={700}
              color="text.primary"
              gutterBottom
            >
              {t("configuration.lockers.title")}
            </Typography>
            <Typography
              data-testid="lockers-coming-soon"
              variant="body1"
              color="text.secondary"
            >
              {t("configuration.lockers.comingSoon")}
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Box>
  )
}
